// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"71b8aba5","329":"2d723093","500":"e80ccaae","647":"d6865e90","881":"011ef3fa","904":"118df727"}[chunkId] + ".chunk.js";
};